import axiosClient from './axiosClient';

export default {
  list: (filters, page = 0, size = 10, sort = 'dataCreazione,DESC') =>
  axiosClient.post('/documenti/search',filters, { params }),
  listbycontribuente: (contribuenteId, filters, page = 0, size = 10, sort = 'dataCreazione,DESC') =>
    axiosClient.post(`/documenti/bycontribuente/${contribuenteId}`, filters, page,size,sort),
  listbystudio: (studioId, params) =>
    axiosClient.get(`/documenti/bystudio/${studioId}`, { params }),
  get: (id) => axiosClient.get(`/documenti/${id}`),

  create: (data, documentoFascicoloId,praticaId) =>
    axiosClient.post('/documenti', data,
    {
      params: {
      ...(documentoFascicoloId ? { documentoFascicoloId } : {}),
     ...(praticaId ? { praticaId } : {})
     }
    }
    ),

  update: (id, data, documentoFascicoloId) =>
    axiosClient.put(`/documenti/${id}`, data, { params: documentoFascicoloId ? { documentoFascicoloId } : {} }),

  delete: (id) => axiosClient.delete(`/documenti/${id}`),

  downloadDocumento: (documentoId, filename) =>
    axiosClient.get(`/documenti/${documentoId}/download`, {
      params: { filename },
      responseType: 'blob'
    }),

  newpreviewupload: (formData, documentoFascicoloId) => {
    if (documentoFascicoloId) formData.append('documentoFascicoloId', documentoFascicoloId);
    return axiosClient.post(`/documenti/nuovo/previewupload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  previewupload: (id, formData, documentoFascicoloId) => {
    if (documentoFascicoloId) formData.append('documentoFascicoloId', documentoFascicoloId);
    return axiosClient.post(`/documenti/${id}/previewupload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  uploadPdf: (formData) =>
    axiosClient.post(`/documenti/nuovo/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 600000
    }),

  addPdf: (id, formData, documentoFascicoloId) => {
    if (documentoFascicoloId) formData.append('documentoFascicoloId', documentoFascicoloId);
    return axiosClient.post(`/documenti/${id}/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 600000
    });
  },
  mergeDocumenti: (documentiIds) =>
    axiosClient.post('/documenti/merge', {
      documentiIds
    }),
};